import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  { path: "/", name: "home" },
  { path: "/delete", name: "delete" },
  { path: "/terms", name: "term" },
  { path: "/privacy", name: "privacy" },
];

export default new VueRouter({
  mode: "history",
  routes,
});